import { render, staticRenderFns } from "./BlogLikePrompt.vue?vue&type=template&id=14d96d82&scoped=true"
import script from "./BlogLikePrompt.vue?vue&type=script&lang=js"
export * from "./BlogLikePrompt.vue?vue&type=script&lang=js"
import style0 from "./BlogLikePrompt.vue?vue&type=style&index=0&id=14d96d82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d96d82",
  null
  
)

export default component.exports